import queryString from "query-string";

export default function objToStr(obj = {}) {
  return queryString.stringify(obj);
}
